import { Box, Typography, Button, Divider, Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Navigation } from "./navigation";
import { Footer } from "./Footer";
import HomeSection2 from "./homepage/RatingSection";
import FacultySection from "./homepage/FacultyList";
import IframFormSection from "./homepage/IframeSection";
import instId from "./network/instituteId";
import axios from "axios";
import EastIcon from '@mui/icons-material/East';
import { BASE_URL } from "./network/endpoints";

const TermsAndConditions = () => {

    const isMobile = useMediaQuery("(min-width:600px)");
    const [Endpoints, setEndpoints] = useState('')

    useEffect(() => {
        window.scrollTo(0, 0);
        getInstituteDetail();
    }, []);

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl)
                // Endpoints = response?.data?.instituteTechSetting?.mediaUrl
            };
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <React.Fragment>
            <div className="" style={{ padding: '8rem 0 0 0' }}>
                <div className="col-xs-12 col-md-12 col-lg-12" style={{ background: "#fff", paddingLeft: "0px", paddingRight: "0px" }}>
                    <div style={{ paddingLeft: isMobile ? '0rem' : '0rem', paddingRight: isMobile ? '0rem' : '0rem', paddingTop: isMobile ? '0rem' : '0rem', paddingBottom: isMobile ? '4rem' : '0rem' }}>
                        <Box sx={{padding: "2rem 6rem"}}>
                            <Typography variant="h4" sx={{fontWeight: "bold", color: "#000", mb:2}}>Terms and Conditions</Typography>
                            <ul>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                   <EastIcon sx={{color: "#000"}} /> &nbsp; Admission once taken will not be cancelled at any cost
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp;  Please be careful while selecting Test Series Subjects and Plan suitable for you. Later on no alterations will be done.
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp;  The Test Series Purchased would be valid only for the attempt for which you have taken it.
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp;  Please note in case of genuine reason only extension for test series will be provided that too only for one Attempt. (6 months)
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp; Refund of fees will not be provided for any reason other than Medical Emergency subject to documentation.
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp;   Refund process would take 15 days after due procedure completed from students end.
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp;   Please note the Pattern and Portion of Test Series is designed after due analysis of Past Papers.
                                </li>
                                <li style={{display: "flex", alignItems: "center", marginTop: "5px", marginBottom: "10px" , color: "#000"}}>
                                <EastIcon sx={{color: "#000"}} /> &nbsp; Please watch a video of How to Buy Test Series before buying any Test Series in order to avoid Confusion.
                                </li>
                            </ul>
                        </Box>
                        {/* <HomeSection2 endpointsUrl={Endpoints} />
                        <FacultySection endpointsUrl={Endpoints} />
                        <IframFormSection endpointsUrl={Endpoints} /> */}
                    </div>
                </div>

            </div>
        </React.Fragment>
    );
};

export default TermsAndConditions;
